import React, { useState } from "react";
import Dropdown from "../../../Components/Dropdown";
import JobCard from "./FindJobs/JobCard";
import MyApplications from "./FindJobs/MyApplications";
import { Select, Space } from 'antd';
import comingsoon from "../../../Assets/comingsoon.png"

export default function FindJobs() {

    const [myApplication, setMyApplication] = useState(false);

    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };


    return (
        <div className="py-4 px-8 font-[Roboto] flex justify-center bg-white rounded-lg shadow-md shadow-gray-400">
            <img alt="coming soon" className="h-[99%] w-[60%]" src={comingsoon} />
            {/* {!myApplication ? <><span className="flex justify-end hover:text-[15.5px] cursor-pointer">
                <span className="" onClick={() => {
                    setMyApplication(true)
                }} >My Applications</span>
            </span>
                <div>
                    <span>Find Jobs</span>
                    <div className="flex md:flex-row flex-col md:space-x-2 md:space-y-0 space-y-2 mb-8">
                        <input
                            className="border-[1px] border-[#C6C6C6] border-solid"
                            placeholder="Type Here..."
                            style={{
                                // border: "1px solid #C6C6C6",
                                borderRadius: "4px",
                                width: "100%",
                                height: "45px",
                                paddingLeft: "10px",
                            }}
                        />
                        <button
                            style={{
                                width: "168px",
                                height: "45px",
                                background: "#139588",
                                border: "1px solid #C6C6C6",
                                borderRadius: "4px",
                                color: "white",
                            }}
                        >
                            Search
                        </button>
                    </div>
                    <div className="flex min-[1120px]:flex-row flex-col max-[1120px]:space-y-4 min-[1120px]:space-x-8 justify-start mt-4">
                        <div className="flex flex-col">
                            <span className="mb-2">Project</span>
                            <Space wrap>
                                <Select
                                    defaultValue="Select Project"
                                    style={{ width: 280 }}
                                    onChange={handleChange}
                                    options={[
                                        { value: 'Project1', label: 'Project1' },
                                        { value: 'Project2', label: 'Project2' },
                                        { value: 'Project3', label: 'Project3' },
                                        { value: 'Project4', label: 'Project4', disabled: true },
                                    ]}
                                />
                            </Space>
                        </div>
                        <div className="flex flex-col">
                            <span className="mb-2">Job</span>
                            <Select
                                defaultValue="Select Job"
                                style={{ width: 280 }}
                                onChange={handleChange}
                                options={[
                                    { value: 'Job1', label: 'Job1' },
                                    { value: 'Job2', label: 'Job2' },
                                    { value: 'Job3', label: 'Job3' },
                                    { value: 'Job4', label: 'Job4', disabled: true },
                                ]}
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                    <JobCard />
                </div>
            </> :
                <>
                    <span className='cursor-pointer mb-4' onClick={() => {
                        setMyApplication(false)
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                        </svg>

                    </span>
                    <MyApplications setMyApplication={setMyApplication} />
                </>
            } */}
        </div>
    );
}
